angular.module('picmonicng').directive('squareImage', [
  '$window',
  function ($window) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        angular.element($window).on('resize', function () {
          setHeight();
        });

        function setHeight() {
          if (element.width() != 0) {
            element.height(element.width());
          }
        }

        element.on('load', function () {
          setHeight();
        });

        angular.element(document).ready(function () {
          setHeight();
        });
      },
    };
  },
]);
